import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Custom theme font sizes (`--text-*` in styles/index.css) must be registered,
// otherwise tailwind-merge reads e.g. `text-button-sm` as a text colour and
// drops the real colour class (`text-primary-foreground`) next to it.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['button-label', 'button-sm'],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
